import Wave from "@customer-gallery-public/bottomWave.png";
import { connectWallet } from "@customer-gallery/redux/actionCreators/connectWallet";
import { useNovelCustomerDispatch, useNovelCustomerSelector } from "@customer-gallery/redux/reduxHooks";
import { NovelModal } from "@novel/shared/components/NovelModal";
import { INovelUser } from "@novel/shared/interfaces/NovelUser";
import { useAsyncCallback } from "@novel/shared/utils/useAsyncCallback";
import React, { useState, useCallback, useMemo } from "react";
import { ConnectOrCreateWalletTabbedComponent } from "@novel/shared/components/ConnectWalletComponent/ConnectOrCreateWalletTabbedComponent";
import { SupportedBlockchainType } from "@novel/shared/utils/cryptoLinkUtils";
import { ICryptoWalletCreate } from "@novel/shared/interfaces/CryptoWallet";
import { GalleryAuthWallet } from "@customer-gallery/utils/galleryWallets";
import { Box } from "@novel/shared/components/Box";
import { SignOutButton } from "@customer-gallery/components/SignOutButton";
interface IConnectWalletModalProps {
  readonly user: INovelUser;
  readonly onClose: () => void;
  readonly isFirstWallet?: boolean;
}
export function ConnectWalletModal({
  onClose,
  isFirstWallet
}: IConnectWalletModalProps): JSX.Element {
  const hasUnclaimedTokens = useNovelCustomerSelector(state => !!state.unclaimedTokens?.unclaimedTokens.length);
  const [modalOpen, setModalOpen] = useState(true);
  const dispatch = useNovelCustomerDispatch();

  // delaying to allow animation out
  const finalHandleOnClose = useCallback(() => {
    setModalOpen(false);
    setTimeout(onClose, 300);
  }, [onClose]);
  const onConnectWallet = useAsyncCallback(async (walletCreate: ICryptoWalletCreate) => {
    finalHandleOnClose();
    try {
      const actionResult = await dispatch(connectWallet({
        wallet: walletCreate
      }));
      if (actionResult.type === "ERROR_CONNECTING_WALLET") {
        setModalOpen(true);
      }
    } catch (e) {
      setModalOpen(true);
      throw e;
    }
  }, [dispatch, finalHandleOnClose]);
  return <NovelModal dialogClassName="connect-wallet-modal" className="connect-wallet-modal" unclosable={isFirstWallet} onClose={finalHandleOnClose} open={modalOpen} fullScreenOnMobile>
            <ConnectWalletContents isFirstWallet={isFirstWallet} hasUnclaimedTokens={hasUnclaimedTokens} onConnectWallet={onConnectWallet} onClose={finalHandleOnClose} />
            <img className="wave-image" src={Wave.src} />
        </NovelModal>;
}
interface IConnectWalletContentsProps {
  readonly isFirstWallet?: boolean;
  readonly hasUnclaimedTokens?: boolean;
  readonly onClose: () => void;
  readonly onConnectWallet: (walletProvider: ICryptoWalletCreate) => void;
}
function ConnectWalletContents({
  isFirstWallet,
  hasUnclaimedTokens,
  onClose,
  onConnectWallet
}: IConnectWalletContentsProps) {
  const novelUserEmail = useNovelCustomerSelector(state => state.auth.user?.primaryEmail);
  const initialConnectAndForClaiming = !!isFirstWallet && !!hasUnclaimedTokens;
  const supportedBlockchainTypes: SupportedBlockchainType[] = useMemo(() => initialConnectAndForClaiming ? ["evm"] : ["evm", "solana"], [initialConnectAndForClaiming]);
  const superUser = useNovelCustomerSelector(state => !!state.auth.user?.isSuperUser);
  return <React.Fragment>
            <NovelModal.Header onClose={onClose}>
                <NovelModal.Title className="Connect-Title">
                    {!isFirstWallet ? "Manage Connected Wallets" : "Connecting your first wallet"}
                </NovelModal.Title>
            </NovelModal.Header>
            <NovelModal.Body>
                <Box justifyContent="center" alignItems="center" mb={1} column rowGap={0.4}>
                    <small>Logged in with {novelUserEmail || ""}</small>
                    <Box justifyContent="center" alignItems="center">
                        <small>wrong email?</small>
                        <SignOutButton buttonSmall />
                    </Box>
                </Box>
                {isFirstWallet && <div className="connect-wallet-text-description" style={{
        marginBottom: "0.65rem"
      }}>
                        Now that you’ve purchased your NFT, you’ll want a safe and accessible place
                        for you to store it. Enter, your crypto wallet. In the following step, we’ll
                        help you create a new wallet if you’re new to the world of web3 or we’ll
                        help you link your existing wallet if you already have one.
                    </div>}
                <ConnectOrCreateWalletTabbedComponent onConnectWallet={onConnectWallet} blockchainTypes={supportedBlockchainTypes} initialTabId={initialConnectAndForClaiming ? "createWallet" : "connectWallet"} AuthWalletClass={GalleryAuthWallet} superUser={superUser} />
            </NovelModal.Body>
        </React.Fragment>;
}